<script setup lang="ts">
import { useReferral } from '@/composables/referral'
import { useAuth } from '@/composables/auth'
import { useTap } from '@/composables/game/tap'
import { usePlayer } from '@/composables/game/player'
import { useConfig } from '@/composables/game/config'
import TheUpgrades from '@/components/TheUpgrades.vue'
import TheTapUpgrade from '@/components/TheTapUpgrade.vue'
import TheTapBoosters from '@/components/TheTapBoosters.vue'
import TheDailyCheckin from '@/components/TheDailyCheckin.vue'
import router from '@/router'
import { RouteName } from '@/routes'

const { shareReferralUrl } = useReferral()

const { profile } = useAuth()
const { player, upgrade, upgradeTap, coins } = usePlayer()

const { tap: _tap } = useTap()
const { config, upgrades } = useConfig()

function createFloatingNumber(x: number, y: number, number: number) {
  const numberElement = document.createElement('div')
  numberElement.textContent = String(number)
  numberElement.style.left = x + 'px'
  numberElement.style.top = y + 'px'
  numberElement.className = 'floating-number'

  document.body.appendChild(numberElement)

  numberElement.addEventListener('animationend', function () {
    numberElement.remove()
  })
}

function getTapPositions(event: TouchEvent | MouseEvent) {
  if ('x' in event) {
    return [{
      x: event.x,
      y: event.y,
    }]
  } else {
    const positions: { x: number, y: number }[] = []
    for (const touch of event.changedTouches) {
      positions.push({
        x: touch.clientX,
        y: touch.clientY,
      })
    }

    return positions
  }
}

function tap(event: TouchEvent | MouseEvent) {
  event.preventDefault()
  const positions = getTapPositions(event)
  const validTapCount = _tap(positions.length)

  for (const position of positions.slice(0, validTapCount)) {
    createFloatingNumber(position.x, position.y, player.value.tap.earnPerTap)
  }
}
</script>

<template>
  <main>
    Welcome {{ profile.firstName }}
    <a @click="shareReferralUrl">
      Invite others
    </a>
    <div
      class="my-2 bg-blue-700 h-[40px] rounded-lg flex items-center justify-center cursor-pointer"
      @click="router.push({name: RouteName.HOME})"
    >
      Go to KUI
    </div>
    <div
      v-touch:tap="tap"
      style="display:block; height: 300px; width: 300px; border-radius: 50%; border: 1px solid red; text-align: center; touch-action: none"
    >
      Tap
    </div>
    <div>Coins: {{ coins }}</div>
    <div>Energy: {{ player.energy.available }} / {{ player.energy.max }}</div>
    <div>
      Upgrades
      <div
        v-for="section in config.upgradeSections"
        :key="section"
      >
        <h3>{{ section }}</h3>
        <TheUpgrades
          @upgrade="upgrade"
          :upgrades="upgrades.filter(u => u.section === section)"
        />
      </div>
    </div>
    <div>
      Tap upgrades
      <TheTapUpgrade
        @upgrade="upgradeTap"
        :tap-config="config.tap"
      />
    </div>
    <div>
      Tap boosters
      <TheTapBoosters
        @upgrade="upgradeTap"
        :tap-config="config.tap"
      />
    </div>
    <div>
      Daily checkin
      <TheDailyCheckin />
    </div>
  </main>
</template>
